import { useTranslation } from 'react-i18next'

/** VH-222: weeks of data per domain when fewer than the minimum overlap. */
export default function DataReadinessCard({ readiness }) {
  const { t } = useTranslation()
  if (!readiness) return null
  const weeks = readiness.weeks || {}
  return (
    <div className="border border-amber-300 bg-amber-50 rounded-lg p-3 text-sm space-y-2" data-testid="data-readiness">
      <p className="font-medium">{t('systemView.readiness.title')}</p>
      <p>{t('systemView.readiness.text', { min: readiness.min_weeks, overlap: readiness.overlapping_weeks })}</p>
      <ul className="space-y-1">
        {Object.entries(weeks).map(([domain, n]) => (
          <li key={domain} className="flex justify-between gap-2" data-testid={`readiness-${domain}`}>
            <span>{t(`systemView.domains.${domain}`)}</span>
            <span>{t('systemView.readiness.weeks', { weeks: n, missing: readiness.missing_weeks?.[domain] ?? 0 })}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
